import React, { useCallback, useContext } from "react";
import { useRouter } from "next/router";
import { emitUpsellNudgeAction, emitUpsellNudgeImpression, } from "@catchoftheday/analytics";
import { CustomerContext } from "@catchoftheday/customer";
import { useIsInViewport } from "@catchoftheday/utilities";
import { isMembershipFreeTrialEligible, triggerOnePassLinkingModal, triggerOnePassUpsellModal, } from "../../../utilities";
import { UpsellCTAWidget } from "../../pure/UpsellCTAWidget";
export const UpsellCTAWidgetContainer = () => {
    const { data: customer, loggedIn } = useContext(CustomerContext);
    const { asPath } = useRouter();
    const isFreeTrialEligible = isMembershipFreeTrialEligible(customer);
    const isLinked = customer?.membership?.linked;
    const showSecondaryCTA = !loggedIn || !isLinked;
    const onMainCTAClick = useCallback(() => {
        emitUpsellNudgeAction(isFreeTrialEligible ? "freeTrial" : "join");
        triggerOnePassUpsellModal();
    }, [isFreeTrialEligible]);
    const onLinkButtonClick = useCallback(() => {
        emitUpsellNudgeAction("link");
        triggerOnePassLinkingModal({
            originalUrl: asPath,
        });
    }, [asPath]);
    const onLoginClick = useCallback(() => {
        emitUpsellNudgeAction("login");
    }, []);
    const trackImpression = useCallback(() => {
        emitUpsellNudgeImpression();
    }, []);
    const { ref: upsellComponent } = useIsInViewport({
        onComponentSeen: trackImpression,
    });
    return (<UpsellCTAWidget ref={upsellComponent} isLoggedIn={loggedIn} showSecondaryCTA={showSecondaryCTA} isFreeTrialEligible={isFreeTrialEligible} onMainCTAClick={onMainCTAClick} onLinkClick={onLinkButtonClick} onLoginClick={onLoginClick}/>);
};
